import {PrivateRoute} from './components/PrivateRoute';
import {type RouteConfig} from './types';

export const protectRoutes = (routes: RouteConfig[]): RouteConfig[] => {
  return routes.map(route => {
    // If it's an index route, ensure it has no children
    if (route.index) {
      const baseRoute = {
        ...route,
        children: undefined,
      };

      if (route.isPublic) {
        return baseRoute;
      }

      if (route.element) {
        return {
          ...baseRoute,
          element: (
            <PrivateRoute
              forCoach={route.forCoach}
              publicElement={route.publicElement}
            >
              {route.element}
            </PrivateRoute>
          ),
        };
      }

      return baseRoute;
    }

    // For non-index routes, handle children
    const children = route.children ? protectRoutes(route.children) : undefined;
    const baseRoute = {
      ...route,
      children,
    };

    if (route.isPublic) {
      return baseRoute;
    }

    if (route.element) {
      return {
        ...baseRoute,
        element: (
          <PrivateRoute
            forCoach={route.forCoach}
            publicElement={route.publicElement}
          >
            {route.element}
          </PrivateRoute>
        ),
      };
    }

    return baseRoute;
  });
};
